import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    details: {
        organizationName: "",
        orgCode: "",
        isActive: true,
        organizationWorkDays: [],
        orgLogoName: "",
        base64File: null,
        dayOfWeek: [],
        orgMinimumWorkflowStage: null,
        defaultJobOpeningValidityDays: 30,
    }
};

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {
        setOrganizationDetails: (state, action) => {
            state.details = action.payload;
        },
        updateOrganizationField: (state, action) => {
            const { field, value } = action.payload;
            state.details[field] = value;
        },
        resetOrganizationDetails: (state) => {
            state.details = initialState.details;
        }
    }
});

export const { setOrganizationDetails, updateOrganizationField, resetOrganizationDetails } = organizationSlice.actions;

export default organizationSlice.reducer;
